import "./OnlineShoppingCategories.css";

type Category = {
    title: string;
    subtitle: string;
    image: string;
};

const categories: Category[] = [
    {
        title: "Grocery & Gourmet Foods",
        subtitle: "Fresh essentials & pantry",
        image: "https://images.unsplash.com/photo-1542838132-92c53300491e?auto=format&fit=crop&w=700&q=80",
    },
    {
        title: "Clothing & Fashion",
        subtitle: "Trending styles & apparel",
        image: "https://images.unsplash.com/photo-1445205170230-053b83016050?auto=format&fit=crop&w=700&q=80",
    },
    {
        title: "Electronics & Accessories",
        subtitle: "Smart tech & accessories",
        image: "https://images.unsplash.com/photo-1498049794561-7780e7231661?auto=format&fit=crop&w=700&q=80",
    },
    {
        title: "Beauty & Personal Care",
        subtitle: "Beauty & grooming essentials",
        image: "https://images.unsplash.com/photo-1596462502278-27bfdc403348?auto=format&fit=crop&w=700&q=80",
    },
    {
        title: "Baby Essentials",
        subtitle: "Everyday care for little ones",
        image: "https://images.unsplash.com/photo-1519689680058-324335c77eba?auto=format&fit=crop&w=700&q=80",
    },
    {
        title: "Sports & Fitness",
        subtitle: "Gear for active lifestyles",
        image: "https://images.unsplash.com/photo-1517836357463-d25dfeac3438?auto=format&fit=crop&w=700&q=80",
    },
    {
        title: "Home & Household",
        subtitle: "Essentials for every home",
        image: "https://images.unsplash.com/photo-1484101403633-562f891dc89a?auto=format&fit=crop&w=700&q=80",
    },
    {
        title: "Health & Wellness",
        subtitle: "Wellness & daily care",
        image: "https://images.unsplash.com/photo-1505751172876-fa1923c5c528?auto=format&fit=crop&w=700&q=80",
    },
    {
        title: "Bath & Body",
        subtitle: "Self-care & body essentials",
        image: "https://images.unsplash.com/photo-1556228720-195a672e8a03?auto=format&fit=crop&w=700&q=80",
    },
    {
        title: "Industrial Supplies",
        subtitle: "Tools & professional essentials",
        image: "https://images.unsplash.com/photo-1504148455328-c376907d081c?auto=format&fit=crop&w=700&q=80",
    },
];

const OnlineShoppingCategories = () => {
    return (
        <section className="shopping-categories">
            <div className="shopping-categories-header">
                <div>
                    <span>EXPLORE SALAR</span>
                    <h2>Online Shopping Made Easy at Salar</h2>
                    <p>Discover everything you need across our most popular shopping categories.</p>
                </div>
                <button type="button">View All Categories</button>
            </div>
            <div className="shopping-categories-grid">
                {categories.map((category) => (
                    <button type="button" className="shopping-category-card" key={category.title}>
                        <img src={category.image} alt={category.title} />
                        <span className="shopping-category-overlay" />
                        <span className="shopping-category-copy">
                            <strong>{category.title}</strong>
                            <small>{category.subtitle}</small>
                        </span>
                    </button>
                ))}
            </div>
        </section>
    );
};

export default OnlineShoppingCategories;